export default __webpack_public_path__ + "static/media/boxuk.81de41fd.svg";